import { api } from "../.."

const MangersDashboardService = async (employee: string, costCenter: string, status: string, startDate: string, endDate: string) => {

    const response = await api.get('managers/dashboard', {
        params: {
            employee, costCenter, status, startDate, endDate
        }
    });

    return response;

}

const MangersDashboardSearchService = async () => {

    const response = await api.get('managers/dashboard/search');

    return response;

}

export {
    MangersDashboardSearchService,
    MangersDashboardService
}